window.addEventListener('load', () => {
    const bookTrigger = document.querySelector('button.pabau-booknow');

    document.querySelectorAll('a[href^="#book"]').forEach(bookButton => {
        bookButton.addEventListener('click', e => {
            e.preventDefault();

            bookTrigger.click();
        });
    });
});
